"use client";

import type { SortControlProps } from "../../../types/sortControl.type";
import { SortControlDesktop } from "./SortControlDesktop";
import { SortControlMobile } from "./SortControlMobile";

export function SortControl({ sorting }: SortControlProps) {
  return (
    <>
      <SortControlMobile sorting={sorting} />
      <SortControlDesktop sorting={sorting} />
    </>
  );
}
